"use client"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { FC, useState } from "react"
import { BASE_URL } from "@/config"
import axios from "axios"
import { toast } from "sonner"
import { useRefresh } from "react-admin"
import axiosInstance from "@/utils/axiosInstance"
import { Trash } from "lucide-react"
interface Props {
  description?: string;
  id: number;
  resource: string;
  responseMessage?: string;
}
const CommonDelete: FC<Props> = ({ description, id, resource, responseMessage}) => {
  const refresh = useRefresh()
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleDeleteClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setOpen(true)
  }
  const confirmDelete = async () => {
    if (!id) return;
    try {
        await axiosInstance.delete(`/${resource}/${id}`)
        toast(responseMessage || "Record deleted")
        refresh()
    } catch (err: any) {
        toast(err.response.data.message)
    } finally {
      setLoading(false)
        setOpen(false)
    }
  }
  return (
    <>
      <DropdownMenuItem onClick={handleDeleteClick} className="cursor-pointer text-red-600">
        <Trash className="w-4 h-4 text-red-600" /> Delete
      </DropdownMenuItem>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent onClick={(e: any) => e.stopPropagation()}>
          <DialogHeader>
            <DialogTitle>Are you sure you want to delete?</DialogTitle>
            <DialogDescription>
              {description || "This action can not be undone."}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={confirmDelete} variant="destructive">
              Delete
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
export default CommonDelete